import templateReducer from './reducers'

export { default as templateSelectors } from './selectors'
export { default as templateActions } from './actions'
export { default as templateTypes } from './actionTypes'

export default templateReducer
